import { render, staticRenderFns } from "./PackageRoomsView.vue?vue&type=template&id=76ab3ef0"
import script from "./PackageRoomsView.vue?vue&type=script&lang=js"
export * from "./PackageRoomsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports